import { render } from "./Model.vue?vue&type=template&id=fc413792"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"

import "./Model.vue?vue&type=style&index=0&id=fc413792&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Model.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc413792"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc413792', __exports__)) {
    api.reload('fc413792', __exports__)
  }
  
  module.hot.accept("./Model.vue?vue&type=template&id=fc413792", () => {
    api.rerender('fc413792', render)
  })

}


export default __exports__